<template>
  <div class="incoming-job-action-column">
    <WdsMenu
      z-index="100"
      placement="bottom-end"
      manual-trigger
      :global="!isFullscreen"
    >
      <template #trigger="{ toggle }">
        <WdsButtonGhost
          :data-test="'incoming-job-actions-' + input.id"
          @click="toggle"
        >
          <WdsIcon name="overflow-menu-horizontal" :size="16" />
        </WdsButtonGhost>
      </template>

      <WdsMenuOption
        :href="
          laravelNamedRoute(namedRoutes.jobs.show, {
            job: input.id ?? '',
          })
        "
      >
        <WdsStack gap-xs justify-center align-center>
          <WdsIcon name="portfolio" :size="16" />
          <span>{{ $t('View details') }}</span>
        </WdsStack>
      </WdsMenuOption>

      <WdsMenuDivider />

      <WdsMenuOption @click="submit">
        <WdsStack gap-xs justify-center align-center>
          <WdsIcon name="copy" :size="16" />
          <span>{{ $t('Create supplier version') }}</span>
        </WdsStack>
      </WdsMenuOption>
    </WdsMenu>

    <BaseHtmlForm
      ref="formRef"
      :action="`/jobs/${input.number}/create-supplier-version`"
      method="POST"
      hidden
    />
  </div>
</template>

<script setup lang="ts">
import {
  WdsButtonGhost,
  WdsIcon,
  WdsMenu,
  WdsMenuDivider,
  WdsMenuOption,
  WdsStack,
} from '@worksome/wds-components'
import { computed, inject, ref } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { TableFullscreen } from '@/components/GraphqlDataTable/injection'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'

const IncomingJobActionColumn = graphql(`
  fragment IncomingJobActionColumn on Job {
    id
    number
    name
  }
`)

const props = defineProps<{ row: FragmentType<typeof IncomingJobActionColumn> }>()

const isFullscreen = inject(TableFullscreen, ref(false))
const input = computed(() => useFragment(IncomingJobActionColumn, props.row))
const formRef = ref<InstanceType<typeof BaseHtmlForm>>()

const submit = () => {
  formRef.value?.submit()
}
</script>

<style scoped lang="scss">
.incoming-job-action-column {
  :deep(.wds-menu) {
    width: max-content;
  }
}
</style>
